import { Injectable, Inject, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, withLatestFrom, switchMap } from 'rxjs/operators';
import { zefAddError, zefRemoveError } from './errors.action';
import { select, Store } from '@ngrx/store';
import { selectZefErrors } from './errors.selector';
import { SnackErrorComponent } from './modules';
import { UNIQUE_ERRORS, BLACKLISTED_ERRORS } from './errors.constant';

@Injectable()
export class ErrorsEffect {

  #actions$ = inject(Actions);
  #store = inject(Store);
  #snackbar = inject(MatSnackBar);
  #uniqueErrors = inject(UNIQUE_ERRORS);
  #blacklistedErrors = inject(BLACKLISTED_ERRORS);

  onActionWithErrorAdd$ = createEffect(() => this.#actions$.pipe(
    filter((action: any) => action.originalAction
      && action.originalAction.zefError
      && action.meta
      && action.meta.zefError
      && !this.#blacklistedErrors.includes(action.meta.zefError.status)
    ),
    withLatestFrom(this.#store.pipe(select(selectZefErrors))),
    map(([ action, errors ]) => {
      // check if the error we are trying to add is not supposed to be unique
      if (this.#uniqueErrors.length && !!errors.find((err) => this.#uniqueErrors.includes(err.originalError.status))) {
        return undefined;
      }

      return zefAddError(
        action.originalAction.type,
        action.meta.zefError.code,
        action.meta.zefError.message,
        (action.originalAction.data && action.originalAction.data.id)
          ? action.originalAction.data.id
          : undefined,
        action.meta.zefError.originalError,
        action.originalAction.zefError.type,
        action.originalAction
      );
    }),
    filter((a) => !!a)
  ));

  onActionWithErrorRemove$ = createEffect(() => this.#actions$.pipe(
    filter((action) => action.zefError),
    withLatestFrom(this.#store.pipe(select(selectZefErrors))),
    filter(([ action, state ]) => !!state.find((item) => {
      if (action.data && action.data.id) {
        return item.key === action.key && item.id === action.data.id;
      }
      return item.key === action.type;
    })),
    map(([ action ]) => zefRemoveError(action.type, action.data?.id))
  ));

  onErrorAdd$ = createEffect(() => this.#actions$.pipe(
    ofType(zefAddError),
    filter((err) => err.errorType === 'snack'),
    switchMap((data) => this.#snackbar
      .openFromComponent(
        SnackErrorComponent,
        { data, duration: 3000, panelClass: 'zef-snack' }
      )
      .onAction()
      .pipe(map(() => zefRemoveError(data.originalAction.type)))
    )
  ));

}
